
import { Component, Vue, Prop, Getter } from "nuxt-property-decorator";
import { LoginModalValue } from "@/types/components";

@Component
export default class TheList extends Vue {
  @Prop() data: Array<any>;
  @Prop() genre: string;
  @Prop() title!: string;
  @Prop() total!: number;
  @Prop() fetchState!: any;
  @Prop() isMap!: boolean;
  @Prop({ default: true }) isAsta!: boolean;

  @Getter("listlayout/isCard") isCard: boolean;
  @Getter("filter/perPage") rpp!: number;
  @Getter("paginator/currentPage") currentPage!: number;
  @Getter("paginator/rows") rows!: number;
  @Getter("filter/getFilterAll") filter!: any;

  public loginModalData: LoginModalValue = {
    model: false,
    title: "Autenticazione richiesta",
    text: "Registrati o esegui il login poter salvare la tue inserzioni preferite",
    icon: "heart",
    payload: null,
  };
  public shareData = { visible: false, item: null, title: null, id: null, url: null };
  public itemToFavourite: any = {};

  public closeModalAndSetFavourite() {
    this.loginModalData.model = false;
    this.$emit("toggle-favourite", this.itemToFavourite);
  }

  /**
   * Metodo di emit evento di sorting
   */
  public addSortingToStore(e: any) {
    this.$emit("sorted", e);
  }

  /**
   * Metodo di cambio layout da griglia a lista
   */
  public setLayout(layout: string) {
    this.$store.commit("listlayout/setLayout", layout);
  }

  public mapSearch() {
    this.$emit("bounds-changed");
  }

  /**
   * Evento di ricarica dei dati
   */
  public reload() {
    this.$emit("reload");
  }

  public changePage(page: any) {
    this.$emit("change-page", parseInt(page));
  }

  public toggleLoginModal(event: any) {
    this.loginModalData.model = !this.loginModalData.model;
    this.loginModalData.payload = {
      redirectUri: event.redirect,
      id: event.id,
    };
    this.itemToFavourite = event;
  }

  public toggleShareModal(obj: any) {
    this.shareData = { ...obj };
  }

  public async toggleFavourite(id: string) {
    await this.$store.dispatch("wishlist/changeFavourite", id);
  }
}
